import { Component } from "react";
import {Routes, Route, Link} from "react-router-dom";
import "./assets/css/main.css";
import { UserContext } from "./UserContext";

import Sidebar from "./components/Sidebar";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRouteResetUser from "./pages/PublicRouteResetUser.js";

import Dashboard from "./pages/Dashboard";
import ViewLocations from "./pages/ViewLocations";
import LocationDetailsWrapper from "./pages/LocationDetailsWrapper";
import AddLocations from "./pages/AddLocations";
import Sponsorship from "./pages/Sponsorship.js";
import FeeSettings from "./pages/FeeSettings";
import AccountSettings from "./pages/AccountSettings";
import EditAccountSettings from "./pages/EditAccountSettings.js";
import ChangePassword from "./pages/ChangePassword.js";
import MerchantPassword from "./pages/MerchantPassword.js";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword.js";
import Billing from "./pages/Billing.js";
import ManageLicenses from "./pages/ManageLicenses.js";
import CsvUploadForm from "./pages/CsvUploadForm.js";
import ManualUpload from "./pages/ManualUpload.js";
import TransfersPage from "./pages/Transfers.js";
import TransferTable from "./pages/TransferTable.js";
import Marketplace from "./pages/Marketplace.js";
import MyListedLicenses from "./pages/MyListedLicenses.js";
import PaymentSetup from "./pages/PaymentSetup.js";
import Payouts from "./pages/Payouts.js";


const needsPaymentSetup = (user) => {

    if (!user) return false;

    if (user.payment_method === true) return false;

    if (user.payment_method === false) return true;

    return !user.sagent_payment_method_id;

};


class AppShell extends Component {
  static contextType = UserContext;

  renderRoutes = () => (
    <PublicRouteResetUser>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/reset-password/:id/:access_token/:reset_token"
          element={<ResetPassword />}
        />
        <Route
          path="/merchant-password/:registration_id/:reset_token"
          element={<MerchantPassword />}
        />
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <Billing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-licenses"
          element={
            <ProtectedRoute>
              <ManageLicenses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-locations"
          element={
            <ProtectedRoute>
              <ViewLocations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/marketplace"
          element={
            <ProtectedRoute>
              <Marketplace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-listed-licenses"
          element={
            <ProtectedRoute>
              <MyListedLicenses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transfer"
          element={
            <ProtectedRoute>
              <TransferTable />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-locations/:registration_id"
          element={
            <ProtectedRoute>
              <LocationDetailsWrapper />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-locations"
          element={
            <ProtectedRoute>
              <AddLocations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/csv-upload"
          element={
            <ProtectedRoute>
              <CsvUploadForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manual-upload"
          element={
            <ProtectedRoute>
              <ManualUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transfer-locations"
          element={
            <ProtectedRoute>
              <TransfersPage />
            </ProtectedRoute>
          }
        />
        {/*
          Reporting routes intentionally commented out while reporting
          functionality is temporarily disabled.
        */}
          <Route
              path="/payment-setup"
              element={
                  <ProtectedRoute>
                      <PaymentSetup />
                  </ProtectedRoute>
              }
          />
          <Route
              path="/payouts"
              element={
                  <ProtectedRoute>
                      <Payouts />
                  </ProtectedRoute>
              }
          />

          <Route
          path="/sponsorship"
          element={
            <ProtectedRoute>
              <Sponsorship />
            </ProtectedRoute>
          }
        />
        <Route
          path="/fee-settings"
          element={
            <ProtectedRoute>
              <FeeSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account-settings"
          element={
            <ProtectedRoute>
              <AccountSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-account-settings"
          element={
            <ProtectedRoute>
              <EditAccountSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
      </Routes>
    </PublicRouteResetUser>
  );

  render() {
    const { isLoggedIn, user } = this.context || {};
    const layoutClass = isLoggedIn ? "main-layout" : "landing-layout";
    const mainClass = isLoggedIn ? "main-content" : "landing-content";

    return (
      <div className="App">
        <div className={layoutClass}>
          {isLoggedIn && <Sidebar />}
          <main className={mainClass}>
              {isLoggedIn && needsPaymentSetup(user) && (

                  <div className="payment-skip-banner">

                      <strong>Payment setup incomplete.</strong> Add a payout method to

                      start receiving earnings and unlock the full account workflow.

                      <Link className="payment-skip-link" to="/payouts">

                          Complete setup

                      </Link>

                  </div>

              )}
            {this.renderRoutes()}
          </main>
        </div>
      </div>
    );
  }
}

class App extends Component {
  render() {
    return <AppShell />;
  }
}

export default App;
